"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var _AdvancedLinkPopoverDecorator = _interopRequireDefault(require("./AdvancedLinkPopoverDecorator"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var LinkComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(LinkComponent, _React$Component);

  function LinkComponent() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LinkComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LinkComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClick = function (e) {
      var togglePopover = _this.props.togglePopover;
      var getReadOnly = _this.context.getReadOnly;

      if (getReadOnly()) {
        return;
      }

      e.preventDefault();
      togglePopover();
    };

    return _this;
  }

  (0, _createClass2.default)(LinkComponent, [{
    key: "getEntity",
    value: function getEntity() {
      var _this$props = this.props,
          entityKey = _this$props.entityKey,
          contentState = _this$props.contentState;
      return contentState.getEntity(entityKey);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getEntity$getDa = this.getEntity().getData(),
          isNoFollow = _this$getEntity$getDa.isNoFollow,
          isTargetBlank = _this$getEntity$getDa.isTargetBlank,
          url = _this$getEntity$getDa.url;

      var target = isTargetBlank ? '_blank' : '_self';
      var rel = isNoFollow ? 'nofollow' : null;
      return _react.default.createElement(_UILink.default, {
        href: url,
        onClick: this.handleClick,
        rel: rel,
        target: target
      }, this.props.children);
    }
  }]);
  return LinkComponent;
}(_react.default.Component);

LinkComponent.propTypes = {
  entityKey: _propTypes.default.string.isRequired,
  contentState: _propTypes.default.instanceOf(_draftJs.ContentState),
  togglePopover: _propTypes.default.func.isRequired,
  children: _propTypes.default.node
};
LinkComponent.contextTypes = {
  getReadOnly: _propTypes.default.func.isRequired
};

var _default = (0, _AdvancedLinkPopoverDecorator.default)(LinkComponent);

exports.default = _default;
module.exports = exports.default;